import { Injectable } from '@angular/core';
import { MemberDiscountRequest } from './DTOs/member-discount-request';
import { ApiClient } from '../core/api-client.service';
import { GetPendingDiscountsListRequest } from './DTOs/get-pending-discounts-list-request';
import { PendingDiscountsDtRetInfo } from './DTOs/pending-discounts-dt-ret-info';
import { Observable } from 'rxjs';
import { UpdatePendingDiscountRequest } from './DTOs/update-pending-discount-request';
import { VerifyRejectRequest } from '../core/verify-reject-request';
import { PendingDiscountDetails } from './DTOs/pending-discount-details';

@Injectable({
  providedIn: 'root'
})
export class MemberDiscountService {
    
  
    readonly relativeBase = "member-discount/";

    constructor(private http: ApiClient) { }

    submitMemberDiscount(request: MemberDiscountRequest) {
        return this.http.post(this.relativeBase + "submit", request);
    }

    getPendingDiscountsList(req: GetPendingDiscountsListRequest): Observable<PendingDiscountsDtRetInfo> {
        return this.http.post(this.relativeBase + "get-pending-discounts", req);
    }

    getPendingDiscount(id: number): Observable<PendingDiscountDetails> {
        return this.http.get(this.relativeBase + "get-pending-discount-details/" + id);
    }

    changeDiscountStatus(request: VerifyRejectRequest, status: number) {
        if (status == 1)
            return this.http.post(this.relativeBase + "approve", request);
        else
            return this.http.post(this.relativeBase + "reject", request);
    }

    updateDiscount(request: UpdatePendingDiscountRequest) {
        return this.http.post(this.relativeBase + "update", request);
    }
    deleteDiscount(id: number): Observable<boolean> {
        return this.http.post(this.relativeBase + "delete-discount/" + id, null);
    }
}
